import React from 'react'
import styles from './InlinePreview.module.css'

export default function InlinePreview({ file, previewUrl, type }) {
  const isVideo = type === 'video' || file?.type?.startsWith('video/')

  return (
    <div className={styles.wrap}>
      {isVideo ? (
        <video
          src={previewUrl}
          controls
          className={styles.media}
          aria-label="Video preview"
        />
      ) : (
        <img
          src={previewUrl}
          alt="Captured document preview"
          className={styles.media}
        />
      )}
    </div>
  )
}
